import { render, staticRenderFns } from "./GroupsDoc.vue?vue&type=template&id=4f89d340"
import script from "./GroupsDoc.vue?vue&type=script&lang=js"
export * from "./GroupsDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports